import React, { FC } from 'react';
import { IConfig } from '../../types/config';
import { IArticle } from '../../types/article';

import ArticlesRecommended1 from './ArticlesRecommended_1';
import ArticlesRecommended1_1 from './ArticlesRecommended_1_1';
import ArticlesRecommended2 from './ArticlesRecommended_2';

const ArticlesRecommended: FC<{ config: IConfig; articles: IArticle[]; language: string }> = ({
  config,
  articles,
  language,
}) => {
  switch (config.general.articlesRecommended.variant) {
    case 2:
    case '2':
      return <ArticlesRecommended2 language={language} config={config} articles={articles} />;
    case '1.1':
      return <ArticlesRecommended1_1 language={language} config={config} articles={articles} />;
    default:
      return <ArticlesRecommended1 language={language} config={config} articles={articles} />;
  }
};

export default ArticlesRecommended;
